<template lang="pug">
  b-card(no-body)
    b-card-header(header-tag="header" role="tab" header-class="accordion-toggle-button" v-b-toggle="'accordion-' + name")
      .toggle-text.pl-2(:style="'min-width:' + (width - 8)  + 'px;'") {{ keyName }}を選択
    b-collapse(:id="'accordion-' + name" :accordion="'accordion-' + name" role="tabpanel")
      b-card-body.p-2
        b-form-checkbox.mb-2(v-for="option in options" v-model="_value" :key="option.value" :value="option.value"
        ) {{ option.text }}
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";

/**
 * 入力要素コンポーネント(複数選択)
 *
 * - セレクトボックスの入力をサポートする
 * - 既存の入力画面のスタイルが適用される
 * - バリデーターは親コンポーネントのものをInjectionして使用する
 *   - そのため、親コンポーネントでveevalidateをnewしておく必要がある
 */
@Component
export default class MultiSelect extends Vue {
  // 親コンポーネントのバリデーターをInjectionする
  @Inject("$validator") $validator!: Validator;

  /** 親コンポーネントでv-modelで指定した値 */
  @Prop({ required: true })
  value!: number[] | string[];

  /** リスト項目 */
  @Prop()
  options!: Array<{ value: number | string; text: string }>;

  /** 項目名 */
  @Prop({ required: true, type: String })
  keyName!: string;

  /** name属性の値 */
  @Prop({ required: true, type: String })
  name!: string;

  /** 横幅 */
  @Prop({ default: 380 })
  width!: number;

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _value(): number[] | string[] {
    return this.value;
  }

  /** 値が変更されたら親コンポーネントに値を渡す */
  set _value(newValue: number[] | string[]) {
    this.$emit("input", newValue);
    this.$emit("changeIds");
    return;
  }
}
</script>
